import { A } from '@mobily/ts-belt';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, FormHelperText, List, ListItem } from '@mui/material';
import { useTranslate } from 'react-admin';

import { NameMismatch } from '@sh4res/bo-common/components/B2bCampaigns/steps/allocations/AllocationsConfirmationStep';

type Props = {
  nameMismatches: NameMismatch[];
};

export const NameMismatchEmployeeSection = ({ nameMismatches }: Props) => {
  const translate = useTranslate();

  if (A.isEmpty(nameMismatches)) {
    return null;
  }

  return (
    <Box mt={1} sx={{ overflowY: 'auto', maxHeight: '120px' }}>
      <FormHelperText
        sx={{
          fontSize: 14,
          color: 'warning.main',
          display: 'flex',
          alignItems: 'flex-start',
          gap: 0.5,
        }}>
        <WarningAmberIcon sx={{ fontSize: 18, mt: '2px', flexShrink: 0 }} />
        <Box>
          {translate(
            'resources.bo_common.b2b.campaigns.sections.allocations.warnings.name_mismatch',
          )}
          <List dense disablePadding sx={{ mt: 0.5 }}>
            {nameMismatches.map((mismatch, index) => (
              <ListItem key={index} sx={{ display: 'list-item', pl: 2, py: 0 }}>
                {mismatch.fileFullName} → {mismatch.dbFullName}
              </ListItem>
            ))}
          </List>
        </Box>
      </FormHelperText>
    </Box>
  );
};
